var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./SubscriptionCancelledPage.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-6ecff14e!../node_modules/vue-loader/lib/selector?type=template&index=0!./SubscriptionCancelledPage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/SubscriptionCancelledPage.vue
// module id = 298
// module chunks = 2